export const getOrderPaymentState = (order = {}) => {
  const total = Math.max(0, Math.round(Number(order.totalPrice || 0) * 100));
  const confirmedPaid = order.isPaid === true;
  const received = confirmedPaid ? total : Math.max(0, Math.round(Number(order.paidAmount || 0) * 100));
  const pending = Math.max(0, total - received);
  const paid = confirmedPaid || (total > 0 && pending === 0);
  const deferred = Boolean(order.creditSale || order.paymentMethod === 'Pay Later' ||
    order.paymentBreakdown?.some(row => row.channel === 'Pay Later'));
  return { total, received, pending, paid, deferred };
};

export const matchesOrderPaymentFilter = (order, filter = '') => {
  const { paid, received, deferred } = getOrderPaymentState(order);
  switch (filter) {
    case 'paid': return paid;
    case 'unpaid': return !paid && received === 0;
    case 'partial': return !paid && received > 0;
    case 'pay-later': return !paid && deferred;
    default: return true;
  }
};
